// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service from "../../../../proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.js";
import * as Curry from "melange.js/curry.js";

const IdentFlow = {};

function toRequest(code, form) {
  return Curry._3(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.ProcessIdentFlowRequest.make, code, form, undefined);
}

const apiEndpointPrefix = "/ident";

function lookup(code, param) {
  const request = Curry._3(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.LookupIdentFlowRequest.make, code, /* [] */0, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.flow);
              }), Buhta_core__Grpc.makeRpc(request, Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.IdentFlowService.lookupIdentFlow, undefined, undefined, undefined, apiEndpointPrefix + Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.IdentFlowService.LookupIdentFlow.name, undefined, undefined));
}

function $$process(code, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
                return Belt__Belt_Option.getExn(response.flow);
              }), Buhta_core__Grpc.makeRpc(toRequest(code, form), Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.IdentFlowService.processIdentFlow, undefined, undefined, undefined, apiEndpointPrefix + Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow_service.Buhta.Ident.Identification.V1alpha1.IdentFlowService.ProcessIdentFlow.name, undefined, undefined));
}

const IdentFlowService = {
  lookup: lookup,
  $$process: $$process
};

const IdentFlowForm = {};

export {
  IdentFlow ,
  IdentFlowForm ,
  IdentFlowService ,
}
/* Buhta_core__Grpc Not a pure module */
